export default __webpack_public_path__ + "static/media/02.b15faa2c.jpg";